module.exports = __webpack_public_path__ + "static/media/commentSmall.69013090.png";